import { Component } from '@angular/core';
import { NotificationService } from '../../../services/notification.service';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [],
  template: `
    <div
      [class]="
        'invisible opacity-0 z-[999999] notification left-[5%] top-[5%] w-[90%] fixed rounded shadow-md notification-' +
        notificationService.notification().type + ' ' +
        notificationService.notification().textColor +
        (notificationService.notification().message ? ' show' : '') +
        (notificationService.fadingOut() ? ' fade-out' : '')
      "
    >
      <div class="p-4 grid grid-flow-col grid-cols-1">
        <div class="flex items-center">
          {{ notificationService.notification().message }}
        </div>
        <div>
          <button
            class="m-auto bg-transparent pl-2"
            (click)="notificationService.close()"
          >
            X
          </button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent {
  constructor(public notificationService: NotificationService) {}
}
